// Queries cache time should be set as the same value or higher than persister's maxAge.
// Default value for persister's maxAge is 24 hours.
// @see https://tanstack.com/query/latest/docs/framework/react/plugins/persistQueryClient#how-it-works
export const QUERY_PERSISTER_MAG_AGE = Infinity;
export const QUERY_CACHE_TIME = QUERY_PERSISTER_MAG_AGE;

export const QUERY_PERSIST_KEY = "PERSIST";
